import React, { useEffect, useRef } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { common_loadingMoreData, common_allDataLoaded } from '@paraglide/messages';
export var InfiniteScrollList = function(param) {
    var children = param.children, _param_hasNextPage = param.hasNextPage, hasNextPage = _param_hasNextPage === void 0 ? false : _param_hasNextPage, _param_isFetchingNextPage = param.isFetchingNextPage, isFetchingNextPage = _param_isFetchingNextPage === void 0 ? false : _param_isFetchingNextPage, onLoadMore = param.onLoadMore, loadingComponent = param.loadingComponent, endMessage = param.endMessage, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? 0.8 : _param_threshold, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_autoLoad = param.autoLoad, autoLoad = _param_autoLoad === void 0 ? true : _param_autoLoad;
    var loadMoreRef = useRef(null);
    // Intersection Observer를 사용한 자동 로딩
    var isIntersecting = useIntersectionObserver(loadMoreRef, {
        threshold: threshold,
        rootMargin: '100px'
    }).isIntersecting;
    useEffect(function() {
        if (autoLoad && isIntersecting && hasNextPage && !isFetchingNextPage) {
            onLoadMore();
        }
    }, [
        autoLoad,
        isIntersecting,
        hasNextPage,
        isFetchingNextPage,
        onLoadMore
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "infinite-scroll-container ".concat(className)
    }, children, /*#__PURE__*/ React.createElement("div", {
        ref: loadMoreRef,
        className: "load-more-trigger"
    }, isFetchingNextPage && (loadingComponent || /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center items-center py-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "ml-2 text-gray-600"
    }, common_loadingMoreData())))), !hasNextPage && !isFetchingNextPage && /*#__PURE__*/ React.createElement("div", {
        className: "text-center py-4 text-gray-500"
    }, endMessage || common_allDataLoaded()));
};
